package com.patronat.top.ui.organisms.schedule

import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.HorizontalDivider
import androidx.compose.material3.Icon
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.painter.Painter
import androidx.compose.ui.unit.Dp
import androidx.compose.ui.unit.dp
import com.patronat.top.ui.molecules.schedule.WorkScheduleDayRow
import com.patronat.top.ui.models.WorkScheduleDay
import com.patronat.top.ui.theme.AccentPink
import com.patronat.top.ui.theme.MineShaft100
import com.patronat.top.ui.theme.MineShaft950
import com.patronat.top.ui.theme.Primary100
import com.patronat.top.ui.theme.Primary600
import com.patronat.top.ui.theme.VenueSectionTitleText
import com.patronat.top.ui.theme.White

@Composable
fun WorkScheduleSection(
    title: String,
    days: List<WorkScheduleDay>,
    onDaysChange: (List<WorkScheduleDay>) -> Unit,
    modifier: Modifier = Modifier,
    leadingIcon: Painter? = null,
    highlightError: Boolean = false,
    timePlaceholder: String = "hh:mm",
    timeFieldWidth: Dp = 138.dp
) {
    val borderColor = if (highlightError) AccentPink else MineShaft100
    Column(
        modifier = modifier
            .fillMaxWidth()
            .background(White, RoundedCornerShape(12.dp))
            .border(1.dp, borderColor, RoundedCornerShape(12.dp))
            .padding(16.dp)
    ) {
        Row(verticalAlignment = Alignment.CenterVertically) {
            if (leadingIcon != null) {
                Box(
                    modifier = Modifier
                        .size(36.dp)
                        .background(Primary100, RoundedCornerShape(8.dp)),
                    contentAlignment = Alignment.Center
                ) {
                    Icon(
                        painter = leadingIcon,
                        contentDescription = null,
                        modifier = Modifier.size(18.dp)
                    )
                }
                Spacer(modifier = Modifier.width(8.dp))
            }

            Text(
                text = title,
                style = VenueSectionTitleText,
                color = MineShaft950
            )
        }

        Spacer(modifier = Modifier.height(18.dp))

        Column {
            days.forEachIndexed { index, day ->
                WorkScheduleDayRow(
                    day = day,
                    onDayChange = { updated ->
                        onDaysChange(days.replaceDay(updated))
                    },
                    timePlaceholder = timePlaceholder,
                    timeFieldWidth = timeFieldWidth
                )

                if (index < days.lastIndex) {
                    Spacer(modifier = Modifier.height(8.dp))
                }
            }
        }
    }
}

private fun List<WorkScheduleDay>.replaceDay(updated: WorkScheduleDay): List<WorkScheduleDay> {
    return map { if (it.id == updated.id) updated else it }
}
